import React from 'react';
export function FreeTrialHeader() {
  return <div className="pt-32 pb-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-937">
      <div className="animate-fade-up-in" data-id="element-938">
        <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6 text-center" data-id="element-939">
          <span className="text-[#00D4FF]" data-id="element-940">COMPLIMENTARY</span> FREE WEEK
        </h1>
      </div>
    </div>;
}